import { FormikProps } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikFieldString } from 'Components/FormikComponents';
import { Label } from '@brighterion/br-ui';
import { MAX_RANGE_LIMIT, valueHasPAN } from 'Utils';
import EndDateTimePicker from 'Routes/ListManagement/components/EndDateTimePicker';
import StartDateTimePicker from 'Routes/ListManagement/components/StartDateTimePicker';
import { MerchantField, Comment } from './FormFields';
import styles from './styles.css';

type Props = {
    merchantSpecific: boolean;
    error: any;
    formikProps: FormikProps<any>;
};

function RangeForm({ merchantSpecific, error, formikProps }: Props) {
    const { t } = useTranslation();
    const checkComparisonError =
        error?.data?.error?.param === 'from' && +formikProps.values.from > +formikProps.values.to;
    const maxDiffFromAndTo =
        formikProps.values.from && +formikProps.values.to - +formikProps.values.from >= MAX_RANGE_LIMIT;
    const alreadyExist = error?.data?.error?.param === 'from' && error?.data?.error?.message === t('existsFromTo');

    return (
        <>
            {merchantSpecific && <MerchantField formikProps={formikProps} error={error} />}
            <div className={styles.rangeFieldWrapper}>
                <div>
                    <Label label={t('from')} id='from' />
                    <FormikFieldString
                        className={styles.rangeFormField}
                        name='from'
                        handleChange={(e: React.ChangeEvent) => {
                            formikProps.handleChange(e);
                        }}
                        error={!!formikProps.errors.from || checkComparisonError || alreadyExist}
                        dataTestId='list-entry-range-from'
                        allowPan
                    />
                </div>
                <div>
                    <Label label={t('to')} id='to' />
                    <FormikFieldString
                        className={styles.rangeFormField}
                        name='to'
                        handleChange={(e: React.ChangeEvent) => {
                            formikProps.handleChange(e);
                        }}
                        error={!!formikProps.errors.to || checkComparisonError || alreadyExist}
                        dataTestId='list-entry-range-to'
                        allowPan
                    />
                </div>
            </div>

            {!(valueHasPAN(formikProps.values.from) || valueHasPAN(formikProps.values.to)) &&
                (!!formikProps.errors.from ||
                    !!formikProps.errors.to ||
                    checkComparisonError ||
                    alreadyExist ||
                    maxDiffFromAndTo) && (
                    <span className='InputBase__errorText'>
                        {formikProps.errors.from ||
                            formikProps.errors.to ||
                            (checkComparisonError && t('fromLessThanTo')) ||
                            (alreadyExist && t('existsFromTo')) ||
                            (maxDiffFromAndTo && t('maxDiffFromAndTo'))}
                    </span>
                )}
            <StartDateTimePicker formikProps={formikProps} />
            <EndDateTimePicker formikProps={formikProps} />

            <Comment formikProps={formikProps} error={error} />
        </>
    );
}

export default RangeForm;
